module.exports = __webpack_public_path__ + "img/electricCar-blue.9417297d.svg";